import React, { useEffect } from 'react'
import { Link as LinkIcon } from 'lucide-react'

interface SectionHeadingProps {
  id: string
  children: React.ReactNode
  className?: string
  as?: 'h1' | 'h2' | 'h3' | 'h4'
}

const SectionHeading: React.FC<SectionHeadingProps> = ({ id, children, className = '', as = 'h2' }) => {
  // Scroll to section if hash matches on mount or hash change
  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === `#${id}`) {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }
    }

    // Check on mount
    handleHashChange()

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange)
    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [id])

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    window.location.hash = id
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const HeadingTag = as

  return (
    <HeadingTag id={id} className={`group scroll-mt-12 sm:scroll-mt-20 ${className}`}>
      <a
        href={`#${id}`}
        onClick={handleClick}
        className="flex items-center gap-2 no-underline text-gray-900 hover:text-primary-600 transition-colors"
      >
        {children}
        <LinkIcon className="h-4 w-4 opacity-30 group-hover:opacity-100 transition-opacity text-primary-500" />
      </a>
    </HeadingTag>
  )
}

export default SectionHeading
